/*
 * RJ Charm Bar builder v2 — Charm Bar CRO DEV (Oct 2026)
 * Vanilla JS, no dependencies. One instance per [data-rjcb] element.
 * Fixes from the audit: no 50-product cap (C1), all finishing options (C2), real disabled
 * states + validation (C3), grouped cart lines with build id (C4), 15-charm cap for every
 * piece (C5), market currency (C6), saved builds + back button (H3), keyboard/screen reader (H7).
 */
(function () {
  'use strict';
  if (window.__rjcbLoaded) return;
  window.__rjcbLoaded = true;

  var TRAYS = [
    { key: 'all', name: 'All', tint: 'cream' },
    { key: 'ml', name: 'Most loved', tint: 'pink', edit: true },
    { key: 'sc', name: 'Scotland', full: 'Scotland & Edinburgh', tint: 'blue' },
    { key: 'lw', name: 'Letters', full: 'Letters & Words', tint: 'yellow', letters: true },
    { key: 'fd', name: 'Food & Drink', tint: 'pink' },
    { key: 'hl', name: 'Hearts & Love', tint: 'pink' },
    { key: 'fq', name: 'Fun & Quirky', tint: 'yellow' },
    { key: 'os', name: 'Ocean & Summer', tint: 'blue' },
    { key: 'ce', name: 'Stars & Celestial', tint: 'yellow' },
    { key: 'lm', name: 'Lucky & Meaningful', tint: 'blue' },
    { key: 'an', name: 'Animals', tint: 'pink' },
    { key: 'fn', name: 'Flowers & Nature', tint: 'yellow' },
    { key: 'ss', name: 'Sparkle & Shapes', tint: 'blue' },
    { key: 'cx', name: 'Extras', full: 'Connectors & Extras', tint: 'cream' }
    /* 'tf' Travel & Flags is held until its draft charms go live (only 3 active). */
  ];
  var NAME_TO_KEY = {
    'scotland & edinburgh': 'sc', 'letters & words': 'lw', 'food & drink': 'fd', 'hearts & love': 'hl',
    'fun & quirky': 'fq', 'ocean & summer': 'os', 'stars & celestial': 'ce', 'lucky & meaningful': 'lm',
    'animals': 'an', 'flowers & nature': 'fn', 'sparkle & shapes': 'ss', 'travel & flags': 'tf',
    'connectors & extras': 'cx', 'most loved': 'ml'
  };
  var TRAY_INTRO = {
    ml: 'Our most-picked charms right now.',
    sc: 'A little piece of Edinburgh. Our bestsellers live here.',
    lw: 'Pick a letter, then choose gold or silver.',
    cx: 'Clasps and drops to layer and link your charms.'
  };
  var PRICE_BANDS = [
    { key: 'any', label: 'Price' },
    { key: 'lt10', label: 'Under £10', max: 999 },
    { key: '10to12', label: '£10–£12', min: 1000, max: 1200 },
    { key: 'gt12', label: '£12+', min: 1201 }
  ];
  var STORE_KEY = 'rjcb:v1:';
  var MAX_AGE_MS = 1000 * 60 * 60 * 24 * 14;

  /* ---------- helpers ---------- */
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function shortName(title) {
    var L = String(title || '').match(/bubble letter charm\s*-\s*([A-Z])\s*$/i);
    if (L) return 'Letter ' + L[1].toUpperCase();
    return String(title || '').replace(/\s+charm(\s+pendant)?$/i, '').replace(/\s+pendant$/i, '').replace(/\s+charm(?=\s+in\s)/i, '').trim();
  }
  function metalOfText(s) {
    s = String(s || '').toLowerCase();
    var end = s.match(/\b(gold|silver)\s*\)?\s*$/); /* variant titles like "18k gold plated stainless steel - Gold" */
    if (end) return end[1] === 'gold' ? 'g' : 's';
    var g = /gold/.test(s), sv = /silver|stainless/.test(s);
    if (g && !sv) return 'g';
    if (sv && !g) return 's';
    return '';
  }
  function storageGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function storageSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function storageDel(k) { try { window.localStorage.removeItem(k); } catch (e) { /* ignore */ } }
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) { /* never break the builder for analytics */ }
  }
  function buildId() {
    var a = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', s = '';
    for (var i = 0; i < 5; i++) s += a.charAt(Math.floor(Math.random() * a.length));
    return s;
  }
  function fetchText(url) {
    /* No Accept: application/json header: Shopify would answer with its built-in collection JSON instead of our view. */
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' for ' + url);
      return r.text();
    });
  }

  /* ---------- data loading ---------- */
  /* In theme previews, pin the theme id so data requests render with this theme (preview cookies can switch). */
  var PREVIEW = (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') ? '&preview_theme_id=' + Shopify.theme.id : '';
  function loadCollection(handle, count) {
    function page(n) {
      return fetchText('/collections/' + encodeURIComponent(handle) + '?view=rj-charm-data&page=' + n + PREVIEW).then(function (t) { return JSON.parse(t); });
    }
    /* The section passes each collection's product count, so every page (250 each, max 6) is requested at once.
       If the count was missing or out of date, page 1's own page total is used to fetch whatever is left. */
    var known = Math.min(Math.max(1, Math.ceil((+count || 0) / 250)), 6), first = [];
    for (var i = 1; i <= known; i++) first.push(page(i));
    return Promise.all(first).then(function (got) {
      var total = Math.min(got[0].pages || 1, 6), rest = [];
      for (var n = known + 1; n <= total; n++) rest.push(page(n));
      return Promise.all(rest).then(function (more) {
        return got.slice(0, total).concat(more).reduce(function (a, m) { return a.concat(m.products || []); }, []);
      });
    }).catch(function (err) {
      console.warn('[rjcb] collection failed', handle, err);
      return [];
    });
  }
  function loadExtra(handles) {
    if (!handles || !handles.length) return Promise.resolve([]);
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return null;
        return {
          id: p.id, h: p.handle, t: p.title, ty: p.type,
          i: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=360' : null,
          m: ['', '', ''],
          v: p.variants.map(function (v) { return [v.id, v.title, v.price, v.available ? 1 : 0, null]; })
        };
      }).catch(function () { return null; });
    })).then(function (a) { return a.filter(Boolean); });
  }

  /* ---------- builder ---------- */
  function Builder(root) {
    this.root = root;
    this.cfg = JSON.parse($(root, '[data-rjcb-config]').textContent);
    this.max = Math.max(1, parseInt(this.cfg.maxCharms, 10) || 15);
    this.fmt = new Intl.NumberFormat(this.cfg.locale || 'en-GB', { style: 'currency', currency: this.cfg.currency || 'GBP' });
    this.state = { step: 1, chain: null, charms: [], finish: 'hand', tray: 'all', metal: 'all', chainFilter: 'all', pieceMetal: '', inStock: true, price: 'any', q: '' };
    this.chains = [];
    this.charms = [];
    this.byVariant = {};
    this.inCart = {};
    this.storeKey = STORE_KEY + this.cfg.piece;
    this.started = false;
    this._off = [];
    this.init();
  }

  Builder.prototype.money = function (cents) { return this.fmt.format((cents || 0) / 100); };

  /* Count what is already in the bag, so stock caps include earlier builds. */
  Builder.prototype.loadCart = function () {
    var self = this;
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { items: [] }; }).then(function (c) {
      self.inCart = {};
      (c.items || []).forEach(function (it) { self.inCart[it.variant_id] = (self.inCart[it.variant_id] || 0) + it.quantity; });
    }).catch(function () { /* stock is still checked by Shopify at add time */ });
  };

  Builder.prototype.init = function () {
    var self = this, root = this.root;
    this.el = {
      badge: $(root, '[data-rjcb-badge]'), title: $(root, '[data-rjcb-title]'), sub: $(root, '[data-rjcb-sub]'),
      notice: $(root, '[data-rjcb-notice]'), chains: $(root, '[data-rjcb-chains]'), chainToolbar: $(root, '[data-rjcb-chain-toolbar]'),
      tabs: $(root, '[data-rjcb-tabs]'), tabsRow: $(root, '[data-rjcb-tabs-row]'), filters: $(root, '[data-rjcb-filters]'), search: $(root, '[data-rjcb-search]'),
      q: $(root, '[data-rjcb-q]'), grid: $(root, '[data-rjcb-charms]'), empty: $(root, '[data-rjcb-empty]'),
      intro: $(root, '[data-rjcb-tray-intro]'), finish: $(root, '[data-rjcb-finish]'), summary: $(root, '[data-rjcb-summary]'),
      thumbs: $(root, '[data-rjcb-thumbs]'), count: $(root, '[data-rjcb-count]'), total: $(root, '[data-rjcb-total]'),
      next: $(root, '[data-rjcb-next]'), sheet: $(root, '[data-rjcb-sheet]'), sheetBody: $(root, '[data-rjcb-sheet-body]'),
      toast: $(root, '[data-rjcb-toast]'), sticky: $(root, '[data-rjcb-sticky]'), bar: $(root, '[data-rjcb-bar]')
    };
    this.bind();
    this.measureHeader();
    var ticking = false;
    function onMove() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; self.measureHeader(); }); }
    window.addEventListener('resize', onMove, { passive: true });
    window.addEventListener('scroll', onMove, { passive: true });
    this._off.push(function () { window.removeEventListener('resize', onMove); window.removeEventListener('scroll', onMove); });

    var cfg = this.cfg;
    var colls = (cfg.charmCollections || []).slice();
    Promise.all([
      cfg.chainCollection ? loadCollection(cfg.chainCollection) : Promise.resolve([]),
      Promise.all(colls.map(function (h, i) { return loadCollection(h, (cfg.charmCounts || [])[i]); })),
      loadExtra(cfg.extraCharms),
      self.loadCart(),
      fetch(cfg.themeMapUrl).then(function (r) { return r.ok ? r.json() : { map: {} }; }).catch(function () { return { map: {} }; })
    ]).then(function (res) {
      self.prepare(res[0], [].concat.apply([], res[1]).concat(res[2]), (res[4] && res[4].map) || {});
      self.restore();
      self.render();
      track('charm_builder_start', { piece: cfg.piece, chains: self.chains.length, charms: self.charms.length });
    }).catch(function (err) {
      console.error('[rjcb] failed to load', err);
      self.showNotice('Sorry, the Charm Bar didn’t load. Please refresh the page, or <a href="' + esc(cfg.bookingUrl) + '">book a session in Edinburgh</a>.', 'error');
    });
  };

  /* The theme header is sticky via its section-group wrapper; keep our tray bar just below whatever is pinned. */
  Builder.prototype.measureHeader = function () {
    var top = 0;
    $$(document, '.shopify-section-group-header-group, header, theme-header, sticky-header, #shopify-section-header').forEach(function (h) {
      var cs = window.getComputedStyle(h);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = h.getBoundingClientRect();
      if (r.bottom > top && r.top <= 1 && r.height > 0 && r.height < window.innerHeight / 2) top = Math.round(r.bottom);
    });
    if (top !== this._stickyTop) { this._stickyTop = top; this.root.style.setProperty('--rjcb-sticky-top', top + 'px'); }
  };

  /* Normalise products into chain and charm records. */
  Builder.prototype.prepare = function (chainProducts, charmProducts, map) {
    var self = this, seen = {};
    this.chains = chainProducts.filter(function (p) {
      /* Finished pieces (e.g. "Clara's Charm Necklace") sit in the chain collections but are not bases to build on. */
      return p.v && p.v.length && !/assembl|tool/i.test(p.t) && !/charm (necklace|bracelet)\s*$/i.test(p.t);
    }).reduce(function (out, p) {
      /* A chain sold in gold and silver variants becomes one card per metal. */
      var vs = p.v.length > 1 ? p.v : [p.v.filter(function (x) { return x[3]; })[0] || p.v[0]];
      vs.forEach(function (v) {
        var m = metalOfText(v[1]) || metalOfText(p.t);
        var t = p.v.length > 1 && m ? p.t + (m === 's' ? ' in Silver' : ' in Gold') : p.t;
        out.push({ id: v[0], pid: p.id, handle: p.h, title: t, name: t, img: v[5] || p.i, price: v[2], available: !!v[3], qty: v[4], metal: m });
      });
      return out;
    }, []);
    var metalRank = { g: 0, s: 1 };
    this.chains.sort(function (a, b) {
      return (b.available - a.available) || ((metalRank[a.metal] != null ? metalRank[a.metal] : 2) - (metalRank[b.metal] != null ? metalRank[b.metal] : 2)) || (a.price - b.price);
    });

    charmProducts.forEach(function (p) {
      if (!p || seen[p.h]) return;
      var mf = p.m || ['', '', ''];
      var mapped = map[p.h];
      var themes = [];
      if (mf[0]) {
        themes = mf[0].split('|').map(function (s) { return NAME_TO_KEY[s.trim().toLowerCase()]; }).filter(Boolean);
      } else if (mapped) {
        themes = mapped[0].split('.');
      }
      /* Unmapped products only count as charms when their product type says so (excludes chains and finished necklaces). */
      var isCharmType = /^\s*(charms?|(gold|silver) bubble letter charm)\s*$/i.test(p.ty || '');
      if (!themes.length && !mapped && !isCharmType) return; /* not a charm (e.g. a finished necklace) */
      if (/^(hand assembled|assemble it yourself|already got the tools)/i.test(p.t)) return;
      /* The combined "Bubble Letter Charm" product (one variant per letter) is covered by the letter picker. */
      if ((p.v || []).length > 5 && p.v.every(function (v) { return /^[A-Z](\s*\/.*)?$/i.test(String(v[1]).trim()); })) return;
      seen[p.h] = true;
      var edits = mf[1] ? mf[1].split('|').map(function (s) { return NAME_TO_KEY[s.trim().toLowerCase()]; }) : (mapped && mapped[2] ? mapped[2].split(',') : []);
      var productMetal = mf[2] ? metalOfText(mf[2]) : (mapped ? mapped[1] : metalOfText(p.t));
      var variants = (p.v || []).map(function (v) {
        var m = metalOfText(v[1]) || (productMetal === 's' ? 's' : 'g');
        return { id: v[0], vt: v[1], price: v[2], available: !!v[3], qty: v[4], metal: m, img: v[5] || null };
      });
      var letter = (p.t.match(/bubble letter charm\s*-\s*([A-Z])\s*$/i) || [])[1];
      self.charms.push({
        pid: p.id, handle: p.h, title: p.t, name: shortName(p.t), img: p.i, themes: themes.length ? themes : [],
        edits: edits.filter(Boolean), variants: variants, letter: letter ? letter.toUpperCase() : null,
        metals: variants.reduce(function (acc, v) { if (acc.indexOf(v.metal) < 0) acc.push(v.metal); return acc; }, []),
        minPrice: Math.min.apply(null, variants.map(function (v) { return v.price; }))
      });
    });
    this.charms.forEach(function (c) { c.variants.forEach(function (v) { self.byVariant[v.id] = { charm: c, variant: v }; }); });
    this.chains.forEach(function (c) { self.byVariant[c.id] = { chain: c }; });
    var prices = this.chains.map(function (c) { return c.price; });
    if (prices.length) {
      var lo = Math.min.apply(null, prices), hi = Math.max.apply(null, prices);
      this.el.sub.textContent = (lo === hi ? 'Every chain is ' + this.money(lo) : 'Chains from ' + this.money(lo)) + '. Pick gold or silver.';
      this.chainSub = this.el.sub.textContent;
    }
  };

  /* Pick the variant of a charm that matches the active metal filter. */
  Builder.prototype.variantFor = function (charm, metal) {
    var pref = metal && metal !== 'all' ? metal : (this.state.pieceMetal || null);
    var list = charm.variants;
    var match = pref ? list.filter(function (v) { return v.metal === pref; }) : [];
    var pool = match.length ? match : list;
    return pool.filter(function (v) { return v.available; })[0] || pool[0];
  };

  Builder.prototype.countOf = function (variantId) {
    return this.state.charms.filter(function (id) { return id === variantId; }).length;
  };

  Builder.prototype.canAdd = function (variant) {
    if (!variant || !variant.available) return 'sold';
    if (this.state.charms.length >= this.max) return 'max';
    if (variant.qty != null && this.countOf(variant.id) + (this.inCart[variant.id] || 0) >= variant.qty) return 'stock';
    return '';
  };

  /* ---------- state persistence & history ---------- */
  Builder.prototype.save = function () {
    var s = this.state;
    storageSet(this.storeKey, JSON.stringify({ t: Date.now(), step: s.step, chain: s.chain, charms: s.charms, finish: s.finish }));
  };

  Builder.prototype.restore = function () {
    var raw = storageGet(this.storeKey), self = this;
    if (!raw) return;
    var d;
    try { d = JSON.parse(raw); } catch (e) { return; }
    if (!d || Date.now() - (d.t || 0) > MAX_AGE_MS) { storageDel(this.storeKey); return; }
    var dropped = 0;
    var chain = d.chain && this.byVariant[d.chain] && this.byVariant[d.chain].chain;
    if (chain && chain.available) { this.state.chain = chain.id; this.state.pieceMetal = chain.metal || ''; if (chain.metal) this.state.metal = chain.metal; } else if (d.chain) dropped++;
    var counts = {};
    (d.charms || []).forEach(function (id) {
      var hit = self.byVariant[id];
      if (!hit || !hit.variant || !hit.variant.available) { dropped++; return; }
      counts[id] = (counts[id] || 0) + 1;
      if (hit.variant.qty != null && counts[id] + (self.inCart[id] || 0) > hit.variant.qty) { dropped++; return; }
      if (self.state.charms.length < self.max) self.state.charms.push(id); else dropped++;
    });
    if (['hand', 'kit', 'diy'].indexOf(d.finish) > -1) this.state.finish = d.finish;
    if (!this.state.chain && !this.state.charms.length) return;
    var step = Math.min(d.step || 1, this.state.chain ? (this.state.charms.length ? 3 : 2) : 1);
    var hashStep = parseInt((location.hash.match(/step-(\d)/) || [])[1], 10);
    this.state.step = hashStep && hashStep <= step ? hashStep : step;
    this.showNotice('Welcome back — we saved your ' + esc(this.cfg.pieceName) + '.' + (dropped ? ' ' + dropped + ' item' + (dropped > 1 ? 's are' : ' is') + ' no longer available, so we took ' + (dropped > 1 ? 'them' : 'it') + ' out.' : '') +
      ' <button type="button" class="rjcb__link" data-rjcb-reset>Start again</button>', 'info');
    track('charm_builder_restored', { piece: this.cfg.piece, charms: this.state.charms.length, dropped: dropped });
  };

  Builder.prototype.reset = function () {
    storageDel(this.storeKey);
    this.state.chain = null; this.state.charms = []; this.state.finish = 'hand'; this.state.pieceMetal = ''; this.state.metal = 'all';
    this.hideNotice();
    this.go(1, true);
  };

  Builder.prototype.go = function (step, fromHistory) {
    var s = this.state;
    if (step >= 2 && !s.chain) step = 1;
    if (step >= 3 && !s.charms.length) step = 2;
    var changed = s.step !== step, forward = step > s.step;
    s.step = step;
    if (changed && !fromHistory) {
      try { history[forward ? 'pushState' : 'replaceState']({ rjcbStep: step }, '', '#step-' + step); } catch (e) { /* ignore */ }
    }
    this.render();
    this.save();
    if (changed) {
      var top = this.root.getBoundingClientRect().top + window.pageYOffset - (parseInt(this.root.style.getPropertyValue('--rjcb-sticky-top'), 10) || 0) - 8;
      if (window.lenis && typeof window.lenis.scrollTo === 'function') window.lenis.scrollTo(top, { duration: 0.5 });
      else window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.el.title.focus({ preventScroll: true });
      track('charm_builder_step', { piece: this.cfg.piece, step: step });
      if (step === 3) track('charm_builder_completed', { piece: this.cfg.piece, charms: s.charms.length, total: this.total() / 100, currency: this.cfg.currency });
    }
  };

  /* ---------- events ---------- */
  Builder.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-rjcb-goto')) { if (self.el.sheet.open) self.closeSheet(); return self.go(parseInt(t.getAttribute('data-rjcb-goto'), 10)); }
      if (t.hasAttribute('data-rjcb-chain')) return self.pickChain(parseInt(t.getAttribute('data-rjcb-chain'), 10));
      if (t.hasAttribute('data-rjcb-chain-metal')) { self.state.chainFilter = t.getAttribute('data-rjcb-chain-metal'); return self.renderChains(); }
      if (t.hasAttribute('data-rjcb-add')) return self.addCharm(t.getAttribute('data-rjcb-add'));
      if (t.hasAttribute('data-rjcb-sub-one')) return self.removeCharm(parseInt(t.getAttribute('data-rjcb-sub-one'), 10));
      if (t.hasAttribute('data-rjcb-tray')) return self.setTray(t.getAttribute('data-rjcb-tray'));
      if (t.hasAttribute('data-rjcb-metal')) { self.state.metal = t.getAttribute('data-rjcb-metal'); track('charm_filter', { filter: 'metal', value: self.state.metal }); return self.renderCharms(); }
      if (t.hasAttribute('data-rjcb-instock')) { self.state.inStock = !self.state.inStock; return self.renderCharms(); }
      if (t.hasAttribute('data-rjcb-price')) { self.state.price = t.getAttribute('data-rjcb-price'); track('charm_filter', { filter: 'price', value: self.state.price }); return self.renderCharms(); }
      if (t.hasAttribute('data-rjcb-letter')) return self.addLetter(t.getAttribute('data-rjcb-letter'));
      if (t.hasAttribute('data-rjcb-open-search')) return self.openSearch();
      if (t.hasAttribute('data-rjcb-search-close')) return self.closeSearch();
      if (t.hasAttribute('data-rjcb-clear-filters')) { self.state.metal = 'all'; self.state.price = 'any'; self.state.inStock = true; self.state.q = ''; self.el.q.value = ''; self.state.tray = 'all'; return self.renderCharms(); }
      if (t.hasAttribute('data-rjcb-next')) return self.next();
      if (t.hasAttribute('data-rjcb-open-piece')) return self.openSheet();
      if (t.hasAttribute('data-rjcb-sheet-close')) return self.closeSheet();
      if (t.hasAttribute('data-rjcb-move')) { var p = t.getAttribute('data-rjcb-move').split(':'); return self.move(parseInt(p[0], 10), parseInt(p[1], 10)); }
      if (t.hasAttribute('data-rjcb-remove-at')) return self.removeAt(parseInt(t.getAttribute('data-rjcb-remove-at'), 10));
      if (t.hasAttribute('data-rjcb-reset')) return self.reset();
      if (t.hasAttribute('data-rjcb-booking')) track('charm_booking_clicked', { source: 'builder_' + self.cfg.piece });
    });
    root.addEventListener('change', function (e) {
      if (e.target.name === 'rjcb-finish') { var fv = e.target.value; self.state.finish = fv; self.save(); self.renderFinish(); self.renderSummary(); self.renderBar(); var inp = self.el.finish.querySelector('input[value="' + fv + '"]'); if (inp) inp.focus(); track('charm_finish_selected', { option: self.state.finish }); }
    });
    var qTimer;
    this.el.q.addEventListener('input', function () {
      clearTimeout(qTimer);
      qTimer = setTimeout(function () {
        self.state.q = self.el.q.value.trim();
        self.renderCharms();
        if (self.state.q.length > 2) track('charm_search', { term: self.state.q, results: self.lastCount });
      }, 180);
    });
    this.el.sheet.addEventListener('click', function (e) { if (e.target === self.el.sheet) self.closeSheet(); });
    this.el.sheet.addEventListener('close', function () { document.documentElement.classList.remove('rjcb-lock'); });
    /* The bag changed elsewhere (drawer, remove build): refresh stock headroom. Wait for the cart to settle first. */
    var onCart = function () {
      setTimeout(function () { self.loadCart().then(function () { if (self.charms.length && self.state.step === 2) self.renderCharms(); }); }, 800);
    };
    document.addEventListener('cart:refresh', onCart);
    var onPop = function (e) {
      var st = (e.state && e.state.rjcbStep) || parseInt((location.hash.match(/step-(\d)/) || [])[1], 10) || 1;
      if (self.el.sheet.open) self.closeSheet();
      self.go(st, true);
    };
    window.addEventListener('popstate', onPop);
    this._off.push(function () { document.removeEventListener('cart:refresh', onCart); window.removeEventListener('popstate', onPop); });
  };

  Builder.prototype.pickChain = function (id) {
    var hit = this.byVariant[id];
    if (!hit || !hit.chain || !hit.chain.available) return;
    this.state.chain = id;
    this.state.pieceMetal = hit.chain.metal || '';
    if (hit.chain.metal && !this.state.charms.length) this.state.metal = hit.chain.metal;
    this.save();
    this.renderChains();
    this.renderBar();
    var cb = this.el.chains.querySelector('[data-rjcb-chain="' + id + '"]');
    if (cb) cb.focus({ preventScroll: true });
    track('charm_base_selected', { piece: this.cfg.piece, variant_id: id, metal: hit.chain.metal || 'unknown', price: hit.chain.price / 100 });
  };

  Builder.prototype.addCharm = function (key) {
    var hit = this.byVariant[parseInt(key, 10)];
    if (!hit || !hit.variant) return;
    var why = this.canAdd(hit.variant);
    if (why === 'max') return this.toast('That’s the maximum of ' + this.max + ' charms. Remove one to swap it.');
    if (why === 'stock') return this.toast(this.inCart[hit.variant.id] ? 'That’s all we have of ' + hit.charm.name + ' — some are already in your bag.' : 'That’s all we have of ' + hit.charm.name + ' right now.');
    if (why === 'sold') return this.toast(hit.charm.name + ' is sold out.');
    this.state.charms.push(hit.variant.id);
    this.save();
    this.updateCard(hit.charm);
    this.renderBar(true);
    track('charm_added', { variant_id: hit.variant.id, name: hit.charm.name, tray: this.state.tray, price: hit.variant.price / 100, count_after: this.state.charms.length });
  };

  Builder.prototype.addLetter = function (letter) {
    var metal = this.state.metal === 's' ? 's' : (this.state.metal === 'g' ? 'g' : (this.state.pieceMetal === 's' ? 's' : 'g'));
    var c = this.charms.filter(function (x) { return x.letter === letter && x.metals.indexOf(metal) > -1; })[0];
    if (!c) return this.toast('Sorry, we don’t have that letter in ' + (metal === 's' ? 'silver' : 'gold') + '.');
    var v = this.variantFor(c, metal);
    this.addCharm(String(v.id));
    this.renderLetters();
    var lb = this.root.querySelector('[data-rjcb-letter="' + letter + '"]');
    if (lb && !lb.disabled) lb.focus({ preventScroll: true });
  };

  Builder.prototype.removeCharm = function (variantId) {
    var i = this.state.charms.lastIndexOf(variantId);
    if (i < 0) return;
    this.removeAt(i);
  };

  Builder.prototype.removeAt = function (i) {
    var id = this.state.charms[i];
    if (id == null) return;
    this.state.charms.splice(i, 1);
    this.save();
    var hit = this.byVariant[id];
    if (hit && hit.charm) this.updateCard(hit.charm);
    if (this.state.tray === 'lw') this.renderLetters();
    this.renderBar();
    if (this.el.sheet.open) this.renderSheet();
    if (this.state.step === 3) { if (!this.state.charms.length) this.go(2); else { this.renderFinish(); this.renderSummary(); } }
    track('charm_removed', { variant_id: id, count_after: this.state.charms.length });
  };

  Builder.prototype.move = function (i, dir) {
    var a = this.state.charms, j = i + dir;
    if (j < 0 || j >= a.length) return;
    var t = a[i]; a[i] = a[j]; a[j] = t;
    this.save();
    this.renderSheet();
    this.renderBar();
    var btn = this.el.sheetBody.querySelector('[data-rjcb-move="' + j + ':' + dir + '"]') || this.el.sheetBody.querySelector('[data-rjcb-move^="' + j + ':"]');
    if (btn) btn.focus();
  };

  Builder.prototype.setTray = function (key) {
    this.state.tray = key;
    if (this.state.q) { this.state.q = ''; this.el.q.value = ''; this.closeSearch(true); }
    this.renderCharms();
    var active = this.el.tabs.querySelector('[aria-pressed="true"]');
    if (active) active.focus({ preventScroll: true });
    if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    /* Deep in a long tray, switching to a shorter one should land at the start of the new tray, just under the sticky row.
       Use the theme's Lenis scroller when present (a native scrollBy is overridden by it), like go() does. */
    /* Use where the sticky row sits when stuck (top offset + height): if the new tray is shorter the page has already
       shrunk and the row may be scrolled out of its stuck position at this moment. */
    var stickyBottom = (parseInt(this.root.style.getPropertyValue('--rjcb-sticky-top'), 10) || 0) + this.el.sticky.offsetHeight;
    var gridTop = this.el.intro.getBoundingClientRect().top;
    if (gridTop < stickyBottom) {
      var target = window.pageYOffset + gridTop - stickyBottom - 4;
      if (window.lenis && typeof window.lenis.scrollTo === 'function') window.lenis.scrollTo(target, { immediate: true });
      else window.scrollTo(0, target);
    }
    track('charm_tray_view', { tray: key, items: this.lastCount });
  };

  /* v2.8: the search field takes the place of the sticky tray row while it is open. */
  Builder.prototype.openSearch = function () {
    this.el.search.hidden = false;
    if (this.el.tabsRow) this.el.tabsRow.hidden = true;
    this.el.q.focus();
  };
  Builder.prototype.closeSearch = function (silent) {
    this.el.search.hidden = true;
    if (this.el.tabsRow) this.el.tabsRow.hidden = false;
    var sb = this.root.querySelector('[data-rjcb-open-search]');
    if (!silent && sb) sb.focus({ preventScroll: true });
    if (!silent && this.state.q) { this.state.q = ''; this.el.q.value = ''; this.renderCharms(); }
  };

  Builder.prototype.next = function () {
    var s = this.state;
    if (s.step === 1) { if (s.chain) this.go(2); return; }
    if (s.step === 2) { if (s.charms.length) this.go(3); return; }
    if (s.step === 3) this.addToBag();
  };

  Builder.prototype.total = function () {
    var self = this, s = this.state, sum = 0;
    if (s.chain && this.byVariant[s.chain]) sum += this.byVariant[s.chain].chain.price;
    s.charms.forEach(function (id) { var h = self.byVariant[id]; if (h && h.variant) sum += h.variant.price; });
    var f = this.finishVariant();
    if (f && s.step === 3) sum += f.p;
    return sum;
  };

  /* Hand assembly tiers are titled by charm count ("1-2", "3-4", "5-7", "8-10", "10-15"). */
  Builder.prototype.finishVariant = function (key, count) {
    key = key || this.state.finish;
    count = count == null ? this.state.charms.length : count;
    var f = (this.cfg.finishing || []).filter(function (x) { return x.key === key; })[0];
    if (!f || !f.tiers || !f.tiers.length) return null;
    if (key !== 'hand') return f.tiers[0].a === false ? null : f.tiers[0];
    var best = null;
    f.tiers.forEach(function (t) {
      var m = String(t.t).match(/(\d+)\s*[-–]\s*(\d+)/);
      if (m && t.a !== false && count >= +m[1] && count <= +m[2] && !best) best = t;
    });
    return best;
  };

  /* ---------- rendering ---------- */
  Builder.prototype.render = function () {
    var s = this.state, c = this.cfg.copy || {};
    this.root.setAttribute('data-step', s.step);
    $$(this.root, '[data-rjcb-panel]').forEach(function (p) { p.hidden = String(s.step) !== p.getAttribute('data-rjcb-panel'); });
    $$(this.root, '[data-rjcb-goto]').forEach(function (b) {
      var n = parseInt(b.getAttribute('data-rjcb-goto'), 10);
      b.disabled = n > s.step && !(n === 2 && s.chain) && !(n === 3 && s.chain && s.charms.length);
      if (n === s.step) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
      b.classList.toggle('is-done', n < s.step);
    });
    this.el.badge.setAttribute('data-content', 'Step ' + s.step + ' of 3');
    this.el.title.textContent = s.step === 1 ? c.step1Title : s.step === 2 ? c.step2Title : c.step3Title;
    this.el.sub.textContent = s.step === 1 ? (this.chainSub || c.step1Sub) : s.step === 2 ? ('Add up to ' + this.max + ' charms. Tap a tray to browse.') : c.step3Sub;
    if (s.step === 1) this.renderChains();
    if (s.step === 2) { this.renderTabs(); this.renderFilters(); this.renderCharms(); }
    if (s.step === 3) { this.renderFinish(); this.renderSummary(); }
    this.renderBar();
  };

  Builder.prototype.renderChains = function () {
    var self = this, s = this.state;
    var metals = ['all', 'g', 's'].filter(function (m) { return m === 'all' || self.chains.some(function (c) { return c.metal === m; }); });
    this.el.chainToolbar.innerHTML = metals.length > 2 ? '<div class="rjcb__seg" role="group" aria-label="Chain metal">' + metals.map(function (m) {
      var on = s.chainFilter === m;
      return '<button type="button" data-rjcb-chain-metal="' + m + '" aria-pressed="' + on + '">' + (m === 'all' ? 'All' : m === 'g' ? 'Gold' : 'Silver') + '</button>';
    }).join('') + '</div>' : '';
    this.el.chainToolbar.style.minHeight = metals.length > 2 ? '' : '0';
    this.el.chainToolbar.style.marginBottom = metals.length > 2 ? '' : '0';
    var list = this.chains.filter(function (c) { return s.chainFilter === 'all' || !c.metal || c.metal === s.chainFilter; });
    if (!list.length) { this.el.chains.innerHTML = '<p class="rjcb__muted">No chains available right now.</p>'; return; }
    this.el.chains.innerHTML = list.map(function (c, i) {
      var on = s.chain === c.id;
      return '<button type="button" class="rjcb__card rjcb__card--chain' + (on ? ' is-on' : '') + '" data-rjcb-chain="' + c.id + '" aria-pressed="' + on + '"' + (c.available ? '' : ' disabled') + '>' +
        '<span class="rjcb__img"><img src="' + esc(c.img) + '" alt="" width="360" height="360" loading="' + (i < 4 ? 'eager' : 'lazy') + '" decoding="async"></span>' +
        (c.available ? '' : '<span class="rjcb__tag">Sold out</span>') +
        (on ? '<span class="rjcb__tick" aria-hidden="true">Chosen</span>' : '') +
        '<span class="rjcb__name">' + esc(c.title) + '</span><span class="rjcb__price">' + self.money(c.price) + '</span></button>';
    }).join('');
  };

  Builder.prototype.trayCounts = function () {
    var self = this, counts = {};
    TRAYS.forEach(function (t) { counts[t.key] = 0; });
    this.charms.forEach(function (c) {
      if (!self.passesFilters(c, true)) return;
      counts.all++;
      c.themes.forEach(function (k) { if (counts[k] != null) counts[k]++; });
      c.edits.forEach(function (k) { if (counts[k] != null) counts[k]++; });
    });
    return counts;
  };

  Builder.prototype.renderTabs = function () {
    var s = this.state, counts = this.trayCounts();
    this.el.tabs.innerHTML = TRAYS.filter(function (t) { return t.key === 'all' || counts[t.key] > 0 || t.letters; }).map(function (t) {
      var on = s.tray === t.key;
      return '<button type="button" class="rjcb__tab rjcb__tab--' + t.tint + '" data-rjcb-tray="' + t.key + '" aria-pressed="' + on + '"' + (t.full ? ' title="' + esc(t.full) + '"' : '') + '>' +
        esc(t.name) + '<span class="rjcb__tab-n">' + counts[t.key] + '</span></button>';
    }).join('');
  };

  Builder.prototype.renderFilters = function () {
    var s = this.state;
    var seg = '<div class="rjcb__seg rjcb__seg--small" role="group" aria-label="Metal">' + [['g', 'Gold'], ['s', 'Silver'], ['all', 'All']].map(function (m) {
      return '<button type="button" data-rjcb-metal="' + m[0] + '" aria-pressed="' + (s.metal === m[0]) + '">' + m[1] + '</button>';
    }).join('') + '</div>';
    var price = this.cfg.currency && this.cfg.currency !== 'GBP' ? '' : '<div class="rjcb__select"><label class="rjcb__visually-hidden" for="rjcb-price-' + this.cfg.sectionId + '">Price</label>' +
      '<select id="rjcb-price-' + this.cfg.sectionId + '" data-rjcb-price-select>' + PRICE_BANDS.map(function (b) {
        return '<option value="' + b.key + '"' + (s.price === b.key ? ' selected' : '') + '>' + b.label + '</option>';
      }).join('') + '</select></div>';
    /* v2.8: search lives in the sticky tray row (section markup), so this row is metal + price only. */
    this.el.filters.innerHTML = '<div class="rjcb__filters-row">' + seg + price + '</div>';
    var self = this, sel = this.el.filters.querySelector('[data-rjcb-price-select]');
    if (sel) sel.addEventListener('change', function () { self.state.price = sel.value; track('charm_filter', { filter: 'price', value: sel.value }); self.renderCharms(); });
  };

  Builder.prototype.passesFilters = function (c, ignoreTray) {
    var s = this.state;
    var v = this.variantFor(c, s.metal);
    if (s.metal !== 'all' && c.metals.indexOf(s.metal) < 0) return false;
    if (s.inStock && !c.variants.some(function (x) { return x.available && (s.metal === 'all' || x.metal === s.metal); })) return false;
    if (s.price !== 'any') {
      var b = PRICE_BANDS.filter(function (x) { return x.key === s.price; })[0];
      var p = v ? v.price : c.minPrice;
      if (b.min != null && p < b.min) return false;
      if (b.max != null && p > b.max) return false;
    }
    if (s.q) {
      var q = s.q.toLowerCase();
      var hay = (c.title + ' ' + c.themes.map(function (k) { var t = TRAYS.filter(function (x) { return x.key === k; })[0]; return t ? (t.full || t.name) : ''; }).join(' ')).toLowerCase();
      if (q.split(/\s+/).some(function (w) { return hay.indexOf(w) < 0; })) return false;
      return true;
    }
    if (ignoreTray || s.tray === 'all') return true;
    return c.themes.indexOf(s.tray) > -1 || c.edits.indexOf(s.tray) > -1;
  };

  Builder.prototype.cardHtml = function (c, i) {
    var v = this.variantFor(c, this.state.metal);
    var n = this.countOf(v.id);
    var why = this.canAdd(v);
    var low = v.available && v.qty === 1;
    var metalLabel = c.metals.length > 1 ? '' : (c.metals[0] === 's' ? 'Silver' : 'Gold');
    return '<div class="rjcb__card rjcb__card--charm' + (n ? ' is-on' : '') + (v.available ? '' : ' is-sold') + '" data-rjcb-card="' + esc(c.handle) + '">' +
      '<button type="button" class="rjcb__card-hit" data-rjcb-add="' + v.id + '" aria-label="Add ' + esc(c.name) + ', ' + this.money(v.price) + (n ? ', ' + n + ' added' : '') + '"' + (why === 'sold' ? ' disabled' : '') + '>' +
      '<span class="rjcb__img"><img src="' + esc(v.img || c.img || '') + '" alt="" width="360" height="360" loading="' + (i < 6 ? 'eager' : 'lazy') + '" decoding="async"></span>' +
      (v.available ? (low ? '<span class="rjcb__tag rjcb__tag--low">Last one</span>' : '') : '<span class="rjcb__tag">Sold out</span>') +
      '<span class="rjcb__name">' + esc(c.name) + '</span>' +
      '<span class="rjcb__meta"><span class="rjcb__price">' + this.money(v.price) + '</span>' + (metalLabel && this.state.metal === 'all' ? '<span class="rjcb__metal rjcb__metal--' + (metalLabel === 'Silver' ? 's' : 'g') + '">' + metalLabel + '</span>' : '') + '</span>' +
      '</button>' +
      (n ? '<span class="rjcb__sticker" aria-hidden="true">×' + n + '</span>' : '') +
      (n ? '<span class="rjcb__stepper"><button type="button" data-rjcb-sub-one="' + v.id + '" aria-label="Remove one ' + esc(c.name) + '">−</button><span>' + n + '</span><button type="button" data-rjcb-add="' + v.id + '" aria-label="Add another ' + esc(c.name) + '"' + (why ? ' disabled' : '') + '>+</button></span>'
         : (v.available ? '<span class="rjcb__plus" aria-hidden="true">+</span>' : '')) +
      '</div>';
  };

  Builder.prototype.updateCard = function (charm) {
    var el = this.el.grid.querySelector('[data-rjcb-card="' + (window.CSS && CSS.escape ? CSS.escape(charm.handle) : charm.handle) + '"]');
    if (!el) return;
    var focusedAdd = document.activeElement && el.contains(document.activeElement) ? document.activeElement.getAttribute('data-rjcb-add') ? 'add' : 'sub' : null;
    var idx = parseInt(el.getAttribute('data-i') || '9', 10);
    var tmp = document.createElement('div');
    tmp.innerHTML = this.cardHtml(charm, idx);
    var fresh = tmp.firstChild;
    fresh.setAttribute('data-i', idx);
    el.parentNode.replaceChild(fresh, el);
    if (focusedAdd) {
      var target = focusedAdd === 'add' ? (fresh.querySelector('.rjcb__stepper [data-rjcb-add]') || fresh.querySelector('[data-rjcb-add]')) : (fresh.querySelector('[data-rjcb-sub-one]') || fresh.querySelector('[data-rjcb-add]'));
      if (target) target.focus();
    }
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) { fresh.classList.add('is-pop'); setTimeout(function () { fresh.classList.remove('is-pop'); }, 260); }
  };

  Builder.prototype.renderCharms = function () {
    var self = this, s = this.state;
    this.renderTabs();
    $$(this.el.filters, '[data-rjcb-metal]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-rjcb-metal') === s.metal)); });
    var stockBtn = this.el.filters.querySelector('[data-rjcb-instock]');
    if (stockBtn) stockBtn.setAttribute('aria-pressed', String(s.inStock));
    var list = this.charms.filter(function (c) { return self.passesFilters(c); });
    var trayKey = s.q ? null : s.tray;
    list.sort(function (a, b) {
      var am = a.edits.indexOf('ml') > -1 ? 0 : 1, bm = b.edits.indexOf('ml') > -1 ? 0 : 1;
      if (trayKey === 'lw') { if (a.letter && b.letter) return a.letter < b.letter ? -1 : 1; if (a.letter) return 1; if (b.letter) return -1; }
      return am - bm || a.name.localeCompare(b.name);
    });
    if (trayKey === 'lw' && !s.q) list = list.filter(function (c) { return !c.letter; });
    this.lastCount = list.length;
    var tray = TRAYS.filter(function (t) { return t.key === s.tray; })[0] || TRAYS[0];
    this.root.setAttribute('data-tint', s.q ? 'cream' : tray.tint);
    var intro = s.q ? 'Results for “' + esc(s.q) + '”' + (s.metal !== 'all' ? ' in ' + (s.metal === 's' ? 'silver' : 'gold') + ' · <button type="button" class="rjcb__link" data-rjcb-metal="all">Show all metals</button>' : '') : (TRAY_INTRO[tray.key] || '');
    this.el.intro.innerHTML = (intro ? '<p>' + intro + '</p>' : '') + (trayKey === 'lw' ? '<div data-rjcb-letters></div>' + (list.length ? '<p class="rjcb__muted">More initials and words</p>' : '') : '');
    if (trayKey === 'lw') this.renderLetters();
    this.el.grid.innerHTML = list.map(function (c, i) { return self.cardHtml(c, i).replace('<div class="rjcb__card', '<div data-i="' + i + '" class="rjcb__card'); }).join('');
    var none = !list.length && trayKey !== 'lw';
    this.el.empty.hidden = !none;
    if (none) this.el.empty.innerHTML = '<p>No charms match those filters.</p><button type="button" class="rjcb__link" data-rjcb-clear-filters>Show all charms</button>';
  };

  Builder.prototype.renderLetters = function () {
    var holder = this.root.querySelector('[data-rjcb-letters]');
    if (!holder) return;
    var self = this, s = this.state;
    var metal = s.metal === 's' ? 's' : s.metal === 'g' ? 'g' : (s.pieceMetal === 's' ? 's' : 'g');
    var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    var price = null;
    var html = letters.map(function (L) {
      var c = self.charms.filter(function (x) { return x.letter === L && x.metals.indexOf(metal) > -1; })[0];
      var v = c && self.variantFor(c, metal);
      var ok = v && v.available && !self.canAdd(v);
      var n = v ? self.countOf(v.id) : 0;
      if (v && price == null) price = v.price;
      return '<button type="button" class="rjcb__letter' + (n ? ' is-on' : '') + '" data-rjcb-letter="' + L + '"' + (ok ? '' : ' disabled') + ' aria-label="' + L + (v ? (v.available ? ', ' + self.money(v.price) : ', sold out') : ', not available') + (n ? ', ' + n + ' added' : '') + '">' + L + (n ? '<span class="rjcb__letter-n">' + n + '</span>' : '') + '</button>';
    }).join('');
    holder.innerHTML = '<div class="rjcb__letters-head"><p class="rjcb__letters-title">Bubble letters' + (price != null ? ' · ' + this.money(price) : '') + '</p>' +
      '<div class="rjcb__seg rjcb__seg--small" role="group" aria-label="Letter metal"><button type="button" data-rjcb-metal="g" aria-pressed="' + (metal === 'g') + '">Gold</button><button type="button" data-rjcb-metal="s" aria-pressed="' + (metal === 's') + '">Silver</button></div></div>' +
      '<div class="rjcb__letters">' + html + '</div>';
  };

  Builder.prototype.renderFinish = function () {
    var self = this, s = this.state, n = s.charms.length;
    this.el.finish.innerHTML = '<legend class="rjcb__finish-legend">How should we put it together?</legend>' + (this.cfg.finishing || []).map(function (f) {
      var v = self.finishVariant(f.key, n);
      var ok = v && v.a !== false;
      var on = s.finish === f.key && ok;
      return '<label class="rjcb__option' + (on ? ' is-on' : '') + (ok ? '' : ' is-disabled') + '">' +
        '<input type="radio" name="rjcb-finish" value="' + f.key + '"' + (on ? ' checked' : '') + (ok ? '' : ' disabled') + '>' +
        '<span class="rjcb__option-main"><span class="rjcb__option-title">' + esc(f.title) + '</span><span class="rjcb__option-note">' + esc(f.note) + '</span></span>' +
        '<span class="rjcb__option-price">' + (v ? (v.p ? '+' + self.money(v.p) : 'Free') : 'Unavailable') + '</span></label>';
    }).join('');
    if (!this.finishVariant()) {
      var firstOk = (this.cfg.finishing || []).filter(function (f) { return self.finishVariant(f.key, n); })[0];
      if (firstOk && firstOk.key !== s.finish) { s.finish = firstOk.key; this.renderFinish(); }
    }
  };

  Builder.prototype.renderSummary = function () {
    var self = this, s = this.state;
    var chain = s.chain && this.byVariant[s.chain] && this.byVariant[s.chain].chain;
    var grouped = [];
    s.charms.forEach(function (id) {
      var g = grouped.filter(function (x) { return x.id === id; })[0];
      if (g) g.n++; else grouped.push({ id: id, n: 1 });
    });
    var rows = '';
    if (chain) rows += '<li><span>' + esc(chain.title) + '</span><span>' + this.money(chain.price) + '</span></li>';
    grouped.forEach(function (g) {
      var h = self.byVariant[g.id];
      rows += '<li><span>' + esc(h.charm.name) + (g.n > 1 ? ' ×' + g.n : '') + '</span><span>' + self.money(h.variant.price * g.n) + '</span></li>';
    });
    var f = this.finishVariant(), fc = (this.cfg.finishing || []).filter(function (x) { return x.key === s.finish; })[0];
    if (f && fc) rows += '<li><span>' + esc(fc.title) + '</span><span>' + (f.p ? this.money(f.p) : 'Free') + '</span></li>';
    this.el.summary.innerHTML = '<h2 class="rjcb__summary-title">Your ' + esc(this.cfg.pieceName) + '</h2><ul class="rjcb__summary-list">' + rows + '</ul>' +
      '<p class="rjcb__summary-total"><span>Total</span><span>' + this.money(this.total()) + '</span></p>' +
      '<p class="rjcb__muted">Discount codes and delivery are added at checkout.</p>' +
      '<button type="button" class="rjcb__link" data-rjcb-goto="2">Edit charms</button>';
  };

  Builder.prototype.renderBar = function (bump) {
    var self = this, s = this.state;
    var chain = s.chain && this.byVariant[s.chain] && this.byVariant[s.chain].chain;
    /* v2.8 compact bar: chain + the two latest charms; the full list is in the review sheet. */
    var thumbs = '';
    if (chain) thumbs += '<img src="' + esc(chain.img) + '" alt="" width="36" height="36" class="is-chain">';
    s.charms.slice(-2).forEach(function (id) { var h = self.byVariant[id]; if (h) thumbs += '<img src="' + esc(h.variant.img || h.charm.img || '') + '" alt="" width="32" height="32">'; });
    if (!chain && !s.charms.length) thumbs = '<span class="rjcb__piece-empty">Your ' + esc(this.cfg.pieceName) + '</span>';
    this.el.thumbs.innerHTML = thumbs;
    var n = s.charms.length;
    this.el.count.textContent = s.step === 1 || !chain ? '' : n + '/' + this.max;
    this.el.count.hidden = !this.el.count.textContent;
    this.el.bar.querySelector('[data-rjcb-open-piece]').setAttribute('aria-label', 'Review your ' + this.cfg.pieceName + (chain ? ', ' + n + ' of ' + this.max + ' charms' : ''));
    var totalText = (chain || n) ? this.money(this.total()) : '';
    this.el.total.textContent = totalText ? 'Total ' + totalText : '';
    var btn = this.el.next, label, ok;
    if (s.step === 1) { ok = !!s.chain; label = ok ? 'Next: add charms' : 'Choose a chain'; }
    else if (s.step === 2) { ok = n > 0; label = ok ? 'Next: finishing' : 'Add your first charm'; }
    else { ok = !!this.finishVariant() && !this.adding; label = this.adding ? 'Adding…' : 'Add to bag'; }
    btn.disabled = !ok;
    btn.setAttribute('aria-disabled', String(!ok));
    /* the running total rides inside the button once there is something to price */
    btn.innerHTML = '<span class="rjcb__cta-label">' + esc(label) + '</span>' + (totalText ? '<span class="rjcb__cta-total">' + esc(totalText) + '</span>' : '');
    if (bump && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.el.bar.classList.remove('is-bump'); void this.el.bar.offsetWidth; this.el.bar.classList.add('is-bump');
    }
  };

  /* ---------- your-piece sheet ---------- */
  Builder.prototype.openSheet = function () {
    this.renderSheet();
    if (typeof this.el.sheet.showModal === 'function') this.el.sheet.showModal(); else this.el.sheet.setAttribute('open', '');
    document.documentElement.classList.add('rjcb-lock');
    track('charm_piece_viewed', { charms: this.state.charms.length });
  };
  Builder.prototype.closeSheet = function () {
    if (typeof this.el.sheet.close === 'function') this.el.sheet.close(); else this.el.sheet.removeAttribute('open');
    document.documentElement.classList.remove('rjcb-lock');
  };
  Builder.prototype.renderSheet = function () {
    var self = this, s = this.state;
    var chain = s.chain && this.byVariant[s.chain] && this.byVariant[s.chain].chain;
    var html = '';
    if (chain) html += '<div class="rjcb__sheet-chain"><img src="' + esc(chain.img) + '" alt="" width="72" height="72"><div><p class="rjcb__sheet-name">' + esc(chain.title) + '</p><p class="rjcb__muted">' + this.money(chain.price) + '</p></div><button type="button" class="rjcb__link" data-rjcb-goto="1">Change</button></div>';
    if (!s.charms.length) html += '<p class="rjcb__muted">No charms yet. Pick a tray and tap a charm to add it.</p>';
    else html += '<p class="rjcb__muted">Charms in order, left to right. Use the arrows to move them.</p><ol class="rjcb__sheet-list">' + s.charms.map(function (id, i) {
      var h = self.byVariant[id];
      return '<li><img src="' + esc(h.variant.img || h.charm.img || '') + '" alt="" width="48" height="48"><span class="rjcb__sheet-name">' + (i + 1) + '. ' + esc(h.charm.name) + '<span class="rjcb__muted"> ' + self.money(h.variant.price) + '</span></span>' +
        '<span class="rjcb__sheet-actions"><button type="button" class="rjcb__icon-btn" data-rjcb-move="' + i + ':-1" aria-label="Move ' + esc(h.charm.name) + ' earlier"' + (i === 0 ? ' disabled' : '') + '>↑</button>' +
        '<button type="button" class="rjcb__icon-btn" data-rjcb-move="' + i + ':1" aria-label="Move ' + esc(h.charm.name) + ' later"' + (i === s.charms.length - 1 ? ' disabled' : '') + '>↓</button>' +
        '<button type="button" class="rjcb__icon-btn" data-rjcb-remove-at="' + i + '" aria-label="Remove ' + esc(h.charm.name) + '">×</button></span></li>';
    }).join('') + '</ol>';
    html += '<p class="rjcb__sheet-total"><span>' + s.charms.length + ' / ' + this.max + ' charms</span><span>' + this.money(this.total()) + '</span></p>';
    this.el.sheetBody.innerHTML = html;
  };

  /* ---------- notices ---------- */
  Builder.prototype.showNotice = function (html, kind) {
    this.el.notice.innerHTML = html;
    this.el.notice.className = 'rjcb__notice rjcb__notice--' + (kind || 'info');
    this.el.notice.hidden = false;
  };
  Builder.prototype.hideNotice = function () { this.el.notice.hidden = true; };
  Builder.prototype.toast = function (msg) {
    var t = this.el.toast;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(this._toastT);
    this._toastT = setTimeout(function () { t.classList.remove('is-on'); t.textContent = ''; }, 3200);
  };

  /* ---------- add to bag (grouped build) ---------- */
  Builder.prototype.addToBag = function () {
    var self = this, s = this.state;
    if (this.adding) return;
    var chain = s.chain && this.byVariant[s.chain] && this.byVariant[s.chain].chain;
    var fin = this.finishVariant();
    var fc = (this.cfg.finishing || []).filter(function (x) { return x.key === s.finish; })[0];
    if (!chain) return this.go(1);
    if (!s.charms.length) return this.go(2);
    if (s.charms.length > this.max) return this.toast('Please remove ' + (s.charms.length - this.max) + ' charm(s).');
    if (!fin || !fc) return this.toast('Please choose how you’d like it put together.');
    var id = buildId(), tag = '#' + id + ' · ' + this.cfg.pieceName.charAt(0).toUpperCase() + this.cfg.pieceName.slice(1);
    var order = s.charms.map(function (vid, i) { var h = self.byVariant[vid], vt = h.variant && h.variant.vt; return (i + 1) + '. ' + h.charm.title + (vt && !/^default title$/i.test(vt) && h.charm.title.indexOf(vt) < 0 ? ' (' + vt + ')' : ''); }).join(', ');
    var counts = {}, seq = [];
    s.charms.forEach(function (vid) { if (!counts[vid]) seq.push(vid); counts[vid] = (counts[vid] || 0) + 1; });
    var items = [{ id: chain.id, quantity: 1, properties: { 'Charm Bar build': tag, 'Charm order': order, 'Finishing': fc.title, '_build_id': id, '_rj_role': 'chain', '_rj_charms': String(s.charms.length) } }];
    seq.forEach(function (vid) { items.push({ id: vid, quantity: counts[vid], properties: { 'Charm Bar build': tag, '_build_id': id, '_rj_role': 'charm' } }); });
    items.push({ id: fin.id, quantity: 1, properties: { 'Charm Bar build': tag, 'For': s.charms.length + ' charm' + (s.charms.length > 1 ? 's' : ''), '_build_id': id, '_rj_role': 'finish', '_rj_finish': s.finish } });
    this.adding = true;
    this.renderBar();
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'We couldn’t add that to your bag.');
        track('charm_add_to_cart', { build_id: id, piece: self.cfg.piece, charms: s.charms.length, finishing: s.finish, value: self.total() / 100, currency: self.cfg.currency });
        storageDel(self.storeKey);
        items.forEach(function (it) { self.inCart[it.id] = (self.inCart[it.id] || 0) + it.quantity; });
        self.state.charms = []; self.state.chain = null; self.state.finish = 'hand'; self.state.step = 1;
        self.adding = false;
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* ignore */ }
        self.showNotice('Added to your bag. <a href="' + esc(self.cfg.cartUrl) + '">View bag</a> · <button type="button" class="rjcb__link" data-rjcb-reset>Make another</button>', 'success');
        self.render();
        self.openCart();
      })
      .catch(function (err) {
        /* Shopify can add part of a multi-item request (e.g. the last charm sold out a second ago) and still return an error.
           Remove anything from this build that did get in, so the bag never holds half a build. */
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          var upd = {}, n = 0;
          (c.items || []).forEach(function (it) { if ((it.properties || {})._build_id === id) { upd[it.key] = 0; n++; } });
          if (!n) return;
          return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) })
            .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); });
        }).catch(function () { /* the cart guard still groups or repairs anything left */ }).then(function () {
          self.adding = false;
          self.renderBar();
          self.showNotice(esc(err.message) + ' Nothing from this build is in your bag, and your choices are still here. Please check stock and try again.', 'error');
          track('charm_add_to_cart_failed', { message: String(err.message).slice(0, 120) });
        });
      });
  };

  Builder.prototype.openCart = function () {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) { window.location.href = this.cfg.cartUrl; return; }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    drawer.classList.add('active');
    document.body.classList.add('open-cart', 'open-cc');
    var recs = drawer.querySelector('.product-recommendations--full');
    if (recs) recs.classList.add('active');
    try { drawer.focus(); } catch (e) { /* ignore */ }
    setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 0);
    if (typeof window.dispatchCustomEvent === 'function') window.dispatchCustomEvent('cart-drawer:open');
  };

  /* Removes page-level listeners (theme editor re-renders the section). */
  Builder.prototype.destroy = function () {
    this._off.forEach(function (fn) { try { fn(); } catch (e) { /* ignore */ } });
    this._off = [];
    document.documentElement.classList.remove('rjcb-lock');
  };

  function boot() { $$(document, '[data-rjcb]').forEach(function (el) { if (!el.__rjcb) el.__rjcb = new Builder(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* Theme editor: start a fresh builder when the section is re-rendered, and clean up the old one. */
  document.addEventListener('shopify:section:unload', function (e) { $$(e.target, '[data-rjcb]').forEach(function (el) { if (el.__rjcb) { el.__rjcb.destroy(); el.__rjcb = null; } }); });
  document.addEventListener('shopify:section:load', boot);
})();
